import superagent from "superagent"
import { API_V2_URL } from "../../base"

export async function orderRating(orderId, ratings, userToken) {
  const URL = `${API_V2_URL}orders/${orderId}/rating`
  const tokenAuth = `Token token=${userToken}`

  const res = await superagent
    .post(URL)
    .set("Accept", "application/json")
    .set("Authorization", tokenAuth)
    .send({
      notes: ratings.other,
      racer_punctuality: ratings.punctuality,
      food_temperature: null, // TODO: remove, kept for compatibility
      racer_courtesy: ratings.politeness,
      food_integrity: ratings.product_integrity,
    })
  return res.body
}
